require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reconnaissance-des-diplmes-2-0-8.json") })
        }
      }, "path---reconnaissance-des-diplmes-2-0-8");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reconnaissance-des-diplmes-2-0-8!./.cache/json/reconnaissance-des-diplmes-2-0-8.json
// module id = 547
// module chunks = 231608221292675